export const columnsStore = [
  { field: "storeName", label: "Store Name" },
  // { field: "ownerName", label: "Owner Name" },
  // { field: "contactDetails", label: "Contact Details" },
  { field: "totalSettle", label: "Total Settle" },
  { field: "paymentDue", label: "Payment Due" },
  { field: "totalFailed", label: "Total Failed" },
  { field: "payoutCount", label: "Payout Count" },
  { field: "action", label: "Action" },
];

export const rowsStore = [
  {
    id: 1,
    storeName: "Sparkle Laundry",
    ownerName: "Ravi Kumar",
    contactDetails: "+91-9876543210",
    totalSettle: "$15,000",
    paymentDue: "$2,500",
  },
  {
    id: 2,
    storeName: "Quick Wash",
    ownerName: "Neha Sharma",
    contactDetails: "+91-9123456780",
    totalSettle: "$22,000",
    paymentDue: "$3,000",
  },
  {
    id: 3,
    storeName: "Urban Clean",
    ownerName: "Amit Patel",
    contactDetails: "+91-9988776655",
    totalSettle: "$18,500",
    paymentDue: "$1,800",
  },
];

export const columnsDelivery = [
  { field: "driverName", label: "Driver Name" },
  // { field: "contactDetails", label: "Contact Details" },
  { field: "totalSettle", label: "Total Settle" },
  { field: "paymentDue", label: "Payment Due" },
  { field: "totalFailed", label: "Total Failed" },
  { field: "payoutCount", label: "Payout Count" },
  { field: "action", label: "Action" },
];

export const  rowsDelivery= [
  {
    id: 1,
    ownerName: "Ravi Kumar",
    contactDetails: "+91-9876543210",
    totalSettle: "$15,000",
    paymentDue: "$2,500",
  },
  {
    id: 2,
    ownerName: "Neha Sharma",
    contactDetails: "+91-9123456780",
    totalSettle: "$22,000",
    paymentDue: "$3,000",
  },
  {
    id: 3,
    ownerName: "Amit Patel",
    contactDetails: "+91-9988776655",
    totalSettle: "$18,500",
    paymentDue: "$1,800",
  },
];

export const columnsHistory = [
  { field: "paymentAmount", label: "Payment Amount" },
  { field: "totalOrderCount", label: "Total Order Count" },
  { field: "totalOrderValue", label: "Total Order Value" },
  { field: "trasactionId", label: "Transaction ID" },
  { field: "paymentFlag", label: "Payment Flag" },
  { field: "paymentDate", label: "Payment Date" },
  { field: "action", label: "Actions" },

];

export const rowsHistory = [
  {
    id: 1,
    paymentAmount: "$12,500",
    totalOrderCount: 45,
    totalOrderValue: "$1,50,000",
    trasactionId: "TXN123456",
    paymentFlag: "Success",
    paymentDate: "2025-08-01",
  },
  {
    id: 2,
    paymentAmount: "$8,200",
    totalOrderCount: 28,
    totalOrderValue: "$95,000",
    trasactionId: "TXN123457",
    paymentFlag: "Pending",
    paymentDate: "2025-08-02",
  },
  {
    id: 3,
    paymentAmount: "$15,000",
    totalOrderCount: 55,
    totalOrderValue: "$1,80,000",
    trasactionId: "TXN123458",
    paymentFlag: "Failed",
    paymentDate: "2025-08-03",
  },
  {
    id: 4,
    paymentAmount: "$10,000",
    totalOrderCount: 38,
    totalOrderValue: "$1,20,000",
    trasactionId: "TXN123459",
    paymentFlag: "Success",
    paymentDate: "2025-08-04",
  },
  {
    id: 5,
    paymentAmount: "$9,700",
    totalOrderCount: 33,
    totalOrderValue: "$1,05,000",
    trasactionId: "TXN123460",
    paymentFlag: "Success",
    paymentDate: "2025-08-05",
  },
];
